/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  authenticated: false,
  admin: null,
  user: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js